import { CollectionFolder } from 'editor/src/store/collections/types';
import addOrApplyCollectionFolderToPageOperation from 'editor/src/store/design/operation/addOrApplyCollectionFolderToPageOperation';
import type { AsyncThunk } from 'editor/src/store/hooks';

import pickSlotFolderOperation from './pickSlotFolderOperation';

/** A folder from the host's library lands in the open builder's picture set when the builder
 *  asked for it, and on the page as a collection layer otherwise. */
const addFolderFromLibraryOperation =
  (folder: CollectionFolder, selectedAssetIds?: string[]): AsyncThunk =>
  async (dispatch, getState) => {
    if (getState().app.slotLayoutBuilder?.folderPick) {
      await dispatch(pickSlotFolderOperation(folder, selectedAssetIds));
      return;
    }
    await dispatch(addOrApplyCollectionFolderToPageOperation(folder, selectedAssetIds));
  };

export default addFolderFromLibraryOperation;
